import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { copiedToClipboard, copiedToClipboardError } from 'src/app/shared/utils/events/copied-to-clipboard.action';

@Component({
    selector: 'app-lobbygram-hook-link-dialog',
    templateUrl: './lobbygram-hook-link-dialog.component.html',
    styleUrls: ['./lobbygram-hook-link-dialog.component.scss'],
    standalone: false
})
export class LobbygramHookLinkDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<LobbygramHookLinkDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public link: string,
    private readonly appStore: Store) { }

  ngOnInit(): void {
  }

  onClipboardCopy(success: boolean): void {
    success ? this.appStore.dispatch(copiedToClipboard()) : this.appStore.dispatch(copiedToClipboardError())
  }


  static createConfigurations(link: string): MatDialogConfig {
    return {
      width: '380px',
      data: link,
      autoFocus: false
    }
  }
}
